import { ExpandingTextArea } from 'foundations-components/transitional/components/ExpandingTextArea';
import { withoutClassName } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ExpandingTextAreaAdapter(props) {
  const rest = withoutClassName(props);
  return /*#__PURE__*/_jsx(ExpandingTextArea, Object.assign({}, rest));
}